import React from "react";
import { useRemoveTag } from "@planzone/view-models";
import { TagIcon } from "./tagIcon";
import { Tag } from "./tag";
import { Props } from "./types";
import styles from "./styles.scss";

function TagList({
  task,
  displayTagMenu,
  removable,
  removableId,
  project,
}: Props) {
  const { isRequestPending, removeTag } = useRemoveTag();

  return (
    <div className={styles.tagList}>
      <div className={styles.list}>
        {task.tags.map((tag) => (
          <Tag
            key={tag.name}
            tag={tag}
            remove={() =>
              !isRequestPending &&
              removeTag({
                removable,
                removableId,
                tag,
                project,
              })
            }
          />
        ))}
        <div className={styles.iconBox}>
          {!isRequestPending && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                displayTagMenu(task, e.clientX, e.clientY);
              }}
            >
              <TagIcon className={styles.icon} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export { TagList };
